<template>
  <div>
    <v-row justify="center">

      <v-col cols="12" md="6" lg="4" xl="3" class="text-center">
        <a @click.stop="helpDialog = true" class="font-weight-bold txt2" style="font-size: .8rem;"><span class="underline px-1">Precisa de ajuda?</span></a>
      </v-col>
    </v-row>
    <v-dialog v-model="helpDialog" max-width="400" >
      <v-card class="pa-4 rounded-lg">
        <v-card-title>Suporte</v-card-title>
        <v-card-text>
          Clique no link abaixo para receber suporte via WhatsApp:
          <v-btn
            depressed
            block
            large
            class="btn-primary mt-6"
            href="https://wa.me/+5521920088559"
            target="_blank"
          >Abrir chat</v-btn>
          <v-btn
            depressed
            block
            large
            text
            class="btn-primary--text mt-3"
            @click.stop="helpDialog = false"
          >Voltar ao site</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      helpDialog: false
    }
  },
}
</script>